// Font loader utility for conditional font loading
export const loadGoogleFonts = (restaurantId) => {
  // Only load fonts for fattyPattyDev
  if (restaurantId === 'fattyPattyDev' || restaurantId === 'fattyPatty') {
    // Check if fonts are already loaded to avoid duplicates
    if (
      document.querySelector(
        'link[href*="fonts.googleapis.com/css2?family=Jost"]'
      )
    ) {
      return;
    }

    // Create preconnect links for better performance
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://fonts.googleapis.com';
    document.head.appendChild(preconnect1);

    const preconnect2 = document.createElement('link');
    preconnect2.rel = 'preconnect';
    preconnect2.href = 'https://fonts.gstatic.com';
    preconnect2.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect2);

    // Create the font link
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href =
      'https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100..900;1,100..900&family=Oswald:wght@200..700&display=swap';
    document.head.appendChild(fontLink);

    // Add font styles to CSS
    const style = document.createElement('style');
    style.textContent = `
      /* Google Fonts - Jost and Oswald (for fattyPattyDev only) */
      .font-jost {
        font-family: 'Jost', sans-serif;
      }

      .font-oswald {
        font-family: 'Oswald', sans-serif;
      }

      /* Font weight utilities for Jost */
      .font-jost-thin { font-family: 'Jost', sans-serif; font-weight: 100; }
      .font-jost-extralight { font-family: 'Jost', sans-serif; font-weight: 200; }
      .font-jost-light { font-family: 'Jost', sans-serif; font-weight: 300; }
      .font-jost-normal { font-family: 'Jost', sans-serif; font-weight: 400; }
      .font-jost-medium { font-family: 'Jost', sans-serif; font-weight: 500; }
      .font-jost-semibold { font-family: 'Jost', sans-serif; font-weight: 600; }
      .font-jost-bold { font-family: 'Jost', sans-serif; font-weight: 700; }
      .font-jost-extrabold { font-family: 'Jost', sans-serif; font-weight: 800; }
      .font-jost-black { font-family: 'Jost', sans-serif; font-weight: 900; }

      /* Font weight utilities for Oswald */
      .font-oswald-extralight { font-family: 'Oswald', sans-serif; font-weight: 200; }
      .font-oswald-light { font-family: 'Oswald', sans-serif; font-weight: 300; }
      .font-oswald-normal { font-family: 'Oswald', sans-serif; font-weight: 400; }
      .font-oswald-medium { font-family: 'Oswald', sans-serif; font-weight: 500; }
      .font-oswald-semibold { font-family: 'Oswald', sans-serif; font-weight: 600; }
      .font-oswald-bold { font-family: 'Oswald', sans-serif; font-weight: 700; }
    `;
    document.head.appendChild(style);
  }
};

// Helper function to get font family based on restaurant ID
export const getFontFamily = (restaurantId, fontType = 'jost') => {
  if (restaurantId === 'fattyPattyDev' || restaurantId === 'fattyPatty') {
    return fontType === 'jost' ? 'Jost, sans-serif' : 'Oswald, sans-serif';
  }
  return 'inherit'; // Default to inherited font
};

// Helper function to get font class based on restaurant ID
export const getFontClass = (
  restaurantId,
  fontType = 'jost',
  weight = 'normal'
) => {
  if (restaurantId === 'fattyPattyDev' || restaurantId === 'fattyPatty') {
    return `font-${fontType}-${weight}`;
  }
  return ''; // Return empty string for other restaurants
};
